<section class="top-failures" [attr.aria-labelledby]="headingId">
  <to-section-title
    [headingId]="headingId"
    [title]="'liveDashboard.testmanager.topFailures.title' | translate"
    [subtitle]="'liveDashboard.testmanager.topFailures.subtitle' | translate"
  />

  <div class="top-failures__list">
    @for (item of failures(); track item.testCaseId; let first = $first) {
      @if (detailLink(item); as link) {
        <a
          class="top-failures__row top-failures__row--link"
          data-testid="top-failure"
          [class.top-failures__row--first]="first"
          [routerLink]="link"
          [attr.aria-label]="
            'liveDashboard.testmanager.topFailures.openAria' | translate: { code: item.key, title: item.title }
          "
        >
          <code class="top-failures__chip">{{ item.key }}</code>
          <span class="top-failures__title">{{ item.title }}</span>
          <span class="top-failures__count">{{ item.count }}×</span>
        </a>
      } @else {
        <div class="top-failures__row" data-testid="top-failure" [class.top-failures__row--first]="first">
          <code class="top-failures__chip">{{ item.key }}</code>
          <span class="top-failures__title">{{ item.title }}</span>
          <span class="top-failures__count">{{ item.count }}×</span>
        </div>
      }
    }
  </div>
</section>
